<template>
  <transition @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false" appear>
    <section :class="this.name">
      <div id="home-bg" class="player cover"></div>
      <div class="bg"></div>
      <div class="content">
        <div class="cont">
          <h2>진카마엘</h2>
          <p>UPDATE- 2019. 02. 27</p>
          <p>어둠의 영혼으로 누구보다 강한 힘을, 빛의 영혼으로 그 누구도 대적 못할 그들!</p>
          <p>거인의 최종 병기 카마엘이여 - 이제 은둔에서 벗어나 진짜 모습으로 세상을 호령하라!</p>
        </div>
      </div>
    </section>
  </transition>
</template>
<script>
    import BasePage from './mixins/basePage.js';
    import {rePostionContents, reSizeBackground} from '@/utils/cavasResize';
    import canvasObjPosition from '@/utils/canvasObjPosition';


    export default {
        name: 'home',
        mixins:[BasePage],
        data() {
            return {
                name:'home',
                contentData:[
                    {type:'bg', source:this.$staticUrl+'img/bg_1.jpg', objName:'bg'}
                    //{type:'bg', source:this.$staticUrl+'img/bg_1.mp4', objName:'bgmovie'}
                ],
                bgPlayer:''
            };
        },
        methods: {
            canvasSet(){
                this.bgPlayer = new nc.promokit.Player({
                    selector: '#home-bg',
                    videoId: 'https://vod.plaync.com/lineage2/old/190220_jinkamael/Jinkamael_1.mp4',
                    mute: true,
                    controls: false,
                    coverClick: false,
                    loop: true,
                    autoPlay:true
                });
                this.bgPlayer.pause();
                TweenMax.set(this.$el.querySelector('#home-bg'), {autoAlpha:0});

                this.baseCavasSet(this.contentData);
                let textureArray = [];
                for (let i=0; i < 90; i++)
                {
                    let texture = PIXI.Texture.fromImage(this.$staticUrl+`img/logo_loop/title_${i}.png`);
                    textureArray.push(texture);
                };

                this.cvObj.logoLoop = new PIXI.extras.AnimatedSprite(textureArray);
                this.cvObj.logoLoop.anchor.set(0.5, 0);
                this.cvObj.logoLoop.x = this.contentSize.w/2 + 15;
                this.cvObj.logoLoop.y = 210 ;
                this.cvObj.logoLoop.animationSpeed = 0.4
                this.cvObj.con.addChild(this.cvObj.logoLoop);
                this.cvObj.logoLoop.play();

                this.cvObj.txtDateCon = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txtDateCon);
                this.cvObj.txtDate = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_1_date.png');
                canvasObjPosition(this.cvObj.txtDate, this.cvObj.txtDateCon, this.contentSize.w/2 -9, 571);

                this.cvObj.txt1Con = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txt1Con);
                this.cvObj.txt1 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_1_txt_1.png');

                canvasObjPosition(this.cvObj.txt1, this.cvObj.txt1Con, this.contentSize.w/2-5, 619);

                this.cvObj.txt2Con = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txt2Con);
                this.cvObj.txt2 =  new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_1_txt_2.png');
                canvasObjPosition(this.cvObj.txt2, this.cvObj.txt2Con, this.contentSize.w/2-5, 656);

                // this.cvObj.txt3Con = new PIXI.Container();
                // this.cvObj.con.addChild(this.cvObj.txt3Con);
                // this.cvObj.txtComLeft =  new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_1_com_l.png');
                // canvasObjPosition(this.cvObj.txtComLeft, this.cvObj.txt3Con, this.contentSize.w/2-108, 772);
                // this.cvObj.txtComRight =  new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_1_com_r.png');
                // canvasObjPosition(this.cvObj.txtComRight, this.cvObj.txt3Con, this.contentSize.w/2+108, 772);
                // this.cvObj.txtComTxt =  new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_1_com_txt.png');
                // canvasObjPosition(this.cvObj.txtComTxt ,this.cvObj.txt3Con, this.contentSize.w/2+3, 799);

                // this.cvObj.txt3Con.interactive = true;
                // this.cvObj.txt3Con.cursor = 'pointer';
                // this.cvObj.txt3Con.pointerdown = (e)=>{
                //     alert('자세한 내용은 2월 27일 공개됩니다.')
                // };
                // this.cvObj.txt3Con.pointerover = function(e){
                //     TweenMax.to(this, 0.3, { pixi: { brightness : 1.5 }})
                // };
                // this.cvObj.txt3Con.pointerout = function(e){
                //     TweenMax.to(this, 0.1, { pixi: { brightness : 1 }})
                // };

                this.cvObj.obj_icon = new PIXI.Sprite.fromImage(this.$staticUrl+'img/ico_scroll.png');
                this.cvObj.obj_icon.anchor.set(0.5, 0);
                this.cvObj.obj_icon.x = this.documentSetSize.width/2 ;
                this.cvObj.obj_icon.y = this.documentSetSize.height - 140 ;
                this.canvas.stage.addChild(this.cvObj.obj_icon);

                this.canvas.ticker.add(()=> {
                    //this.cvFilters.ZoomBlurFilter.speed = Math.random();
                });
            },
            enter (el, done) {
                this.baseEnter();
                this.canvasSet();

                this.baseEnterMotion(el, done, this.contentData);

                this.enterMotion.fromTo(this.cvObj.logoLoop, 1, {pixi: { alpha: 0, brightness: 5}}, { pixi: { alpha: 1, brightness: 1},ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.txt1, 0.7, {pixi: { alpha: 0, scale:0.1}}, {pixi:{scale:1, alpha:1}, ease:Expo.easeOut}, 'bgMotionEnd+=0')
                    .fromTo(this.cvObj.txt1Con, 0.7, {pixi: { blurX: 50}}, {pixi:{blurX:0}}, 'bgMotionEnd+=0')
                    .fromTo(this.cvObj.txt2, 0.7,{pixi: { alpha: 0, scale:0.1}},  {pixi:{scale:1, alpha:1}, ease:Expo.easeOut}, 'bgMotionEnd+=0.4')
                    .fromTo(this.cvObj.txt2Con, 0.7,{pixi: { blurX: 50}},  {pixi:{blurX:0}}, 'bgMotionEnd+=0.4')
                    .fromTo(this.cvObj.txtDate, 0.7, {pixi: { alpha: 0, scale:1.5}}, {pixi:{scale:1, alpha:1}, ease:Expo.easeOut}, 'bgMotionEnd+=1')
                    .fromTo(this.cvObj.txtDateCon, 0.7, {pixi: {brightness: 10}}, {pixi:{brightness: 1}, ease:Expo.easeOut}, 'bgMotionEnd+=1')
                    // .fromTo(this.cvObj.txtComLeft, 0.5, {pixi: {x:this.contentSize.w/2, alpha:0, brightness: 10}}, { pixi: {x:this.contentSize.w/2-108, alpha: 1, brightness: 1}, ease: Back.easeInOut}, 'bgMotionEnd+=1.3')
                    // .fromTo(this.cvObj.txtComRight, 0.5, {pixi: {x:this.contentSize.w/2, alpha:0, brightness: 10}}, { pixi: {x:this.contentSize.w/2+108, alpha: 1, brightness: 1}, ease: Back.easeInOut}, 'bgMotionEnd+=1.3')
                    // .fromTo(this.cvObj.txtComTxt, 0.5, {pixi: { alpha: 0, scale:0.1, brightness: 10}}, {pixi:{scale:1, alpha:1, brightness: 1}, ease:Back.easeInOut}, 'bgMotionEnd+=1.55')
                    .fromTo(this.cvObj.obj_icon, 0.5, {pixi: { alpha: 0, scale:0.1, brightness: 5}}, {pixi:{scale:1, alpha:1, brightness: 1}, ease:Back.easeInOut}, 'bgMotionEnd+=1.3')
                    .call(()=>{
                        this.bgPlayer.seek(1);
                        this.bgPlayer.play();
                        TweenMax.set(this.$el.querySelector('#home-bg'), {autoAlpha:1})
                    })
                    .to(this.cvObj.bg, 0.7, {pixi: { alpha: 0}, delay:0.8 });


                this.enterMotion.play();
            },
            leave (el, done) {
                if(this.enterMotion)this.enterMotion.pause();
                this.cvObj.logoLoop.stop();
                this.baseLeaveMotion(el, done);
            },
            resize(){
                this.documentSetSize.width =  document.querySelector('.container').clientWidth;
                this.documentSetSize.height = document.querySelector('.container').clientHeight;
                if(!this.canvas)return;
                reSizeBackground(this.cvObj.bg, this.documentSetSize.width, this.documentSetSize.height);
                rePostionContents(this.cvObj.con, this.documentSetSize.width, this.documentSetSize.height, this.contentSize.w, this.contentSize.h, true);

                this.cvObj.obj_icon.x =  this.documentSetSize.width/2 ;
                this.cvObj.obj_icon.y = this.documentSetSize.height - 140 ;
                this.canvas.renderer.resize(this.documentSetSize.width, this.documentSetSize.height);

            }
        }
    }
</script>





